export default __webpack_public_path__ + "static/media/engie-logo.7dc426af.svg";